import React, { useEffect, useState, useRef } from "react";
import { RefreshCw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { activateWaitingWorker } from '@/lib/workerUpdate';

export default function AppUpdateGate() {
  const [registration, setRegistration] = useState(null);
  const [open, setOpen] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  const cleanup = useRef(null);
  useEffect(() => () => cleanup.current?.(), []);

  useEffect(() => {
    const onReady = (e) => { setRegistration(e.detail?.registration || null); setOpen(true); };
    window.addEventListener("slx-app-update-ready", onReady);
    if (window.__slxWaitingRegistration?.waiting) onReady({ detail: { registration: window.__slxWaitingRegistration } });
    navigator.serviceWorker?.getRegistration?.().then((reg) => { if (reg?.waiting) onReady({ detail: { registration: reg } }); }).catch(() => {});
    return () => window.removeEventListener("slx-app-update-ready", onReady);
  }, []);

  const apply = async () => {
    setRefreshing(true);
    setUpdateError(false);
    let reg;
    try { reg = registration || await navigator.serviceWorker?.getRegistration?.(); }
    catch { setRefreshing(false); setUpdateError(true); return; }
    const waiting = reg?.waiting;
    if (!waiting) { window.location.reload(); return; }
    cleanup.current?.();
    cleanup.current = activateWaitingWorker(navigator.serviceWorker, waiting, () => window.location.reload(),
      () => { setRefreshing(false); setUpdateError(true); });
  };

  return <Dialog open={open} onOpenChange={() => { /* intentionally user-confirmed only */ }}>
    <DialogContent className="sm:max-w-md border-accent/30" hideClose>
      <DialogHeader>
        <DialogTitle className="font-display text-2xl flex items-center gap-3"><Sparkles className="h-5 w-5 text-accent"/>SLX-one update ready</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground leading-relaxed">A small update is required to keep this device synchronized with the vessel platform. Your signed-in session and cabin/device assignment will remain active.</p>
        {updateError && <p role="alert" className="text-sm text-amber-600">The update has not activated yet. Check the connection and try again.</p>}
        <Button className="w-full" onClick={apply} disabled={refreshing}>
          <RefreshCw className={`h-4 w-4 mr-2 ${refreshing ? "animate-spin" : ""}`}/>{refreshing ? "Refreshing…" : "Refresh now"}
        </Button>
      </div>
    </DialogContent>
  </Dialog>;
}
